if (!customElements.get("banners-list")) {
  class BannersList extends HTMLElement {
    constructor() {
      super();
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      const waitForSwiper = () => {
        if (typeof Swiper !== 'undefined') {
          this.onResize();
        } else {
          requestAnimationFrame(waitForSwiper);
        }
      };
      
      waitForSwiper();
      window.addEventListener("resize", this.onResize);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.onResize);
      this.destroySlider();
    }

    onResize() {
      const isMobile = window.innerWidth <= 1023;
      
      if (isMobile && !this.swiper) {
        this.initSlider();
      } else if (!isMobile && this.swiper) {
        this.destroySlider();
      }
    }

    initSlider() {
      this.slider = this.querySelector(".banners-list__slider");
      this.prevBtn = this.querySelector(".banners-list__prev-btn");
      this.nextBtn = this.querySelector(".banners-list__next-btn");
      this.pagination = this.querySelector(".banners-list__pagination");

      this.swiper = new Swiper(this.slider, {
        slidesPerView: 1,
        spaceBetween: 12,
        speed: 500,

        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },

        pagination: {
          el: this.pagination,
          clickable: true,
            renderBullet: (index, className) => {
            const slide = this.slider.querySelectorAll('.swiper-slide')[index];
            const color = slide?.dataset?.bulletColor
            return `<span class="${className}" style="background-color:${color}"></span>`;
          },
        },

        breakpoints: {
          767: {
            slidesPerView: 1.5,
          },
        }
      });
    }

    destroySlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define("banners-list", BannersList);
}